import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Globals } from 'projects/core/src/globals';
import { Helper } from 'projects/core/src/helper';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode, OrderingMode } from 'projects/core/src/include/structures';
import { Project } from '../../db/project';
import { ProjectsService } from '../../services/projects.service';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent extends ModelList<Project>  implements OnInit {

  filter_status:Filter=new Filter();
  filter_search:Filter=new Filter();
  filter_id_address:Filter=new Filter();
  filter_created_from:Filter=new Filter();
  filter_date:Filter=new Filter();  
  filter_phase:Filter<number>=new Filter<number>();
  filter_fieldvalue:Filter=new Filter();

  isFilterSet:boolean=false;
  
  date_from: Date=new Date();
  date_to: Date=new Date();

  shops=[];
  total=0;
  total_cost=0;
  total_paid=0;
  total_columns:any[]=[];

  @Input()
  id_address:number=0;

  @Input()
  filterbox:boolean=true;

  @Input()
  showAmount=false;

  total_amount_selected:number=0;
  total_paid_selected:number=0;
  total_cost_selected:number=0;
  num_selected:number=0;

  filterTmp="";
  filterFieldValues=[];
  

  constructor(
    private projectsService: ProjectsService,
    private fb1: UntypedFormBuilder,
  ) {
    super(projectsService,fb1);
    this.modulename="project";
    this.detailViewModal=ProjectDetailComponent;
   }

  ngOnInit(): void {
    this.title='Progetti';
    super.ngOnInit.apply(this, arguments); 

    const default_address=Globals.parameters.get("general")?.getParam("default_address");
   
    if(this.mode!="embedded"){
      this.filter_date.mode=FilterMode.date;
      this.filter_date.fields=[];
      this.filter_date.value=Helper.convertDateControl(this.date_from);
      this.filter_date.value2=Helper.convertDateControl(this.date_to);
      this.filter_date.fields.push("p.date");
      this.filter.push(this.filter_date);
    }
    /*
    if(this.mode!="embedded") //se incoroporato in una finestra non avviare subito la ricerca, ma aspetta che il filtro sia attivo
      this.updateList(this.id_address);
    */

    this.afterGetItems=()=>{
      this.total=0;
      this.total_cost=0;
      this.total_paid=0;
      this.total_columns=[];
      for(let l of this.list){
        this.total+=parseFloat(l.amount.toString());
        this.total_cost+=parseFloat(l.cost.toString());
        this.total_paid+=parseFloat(l.paid.toString());
        if(l.customfields){
          for(let i=0;i<l.customfields.length;i++){
            let c = l.customfields[i];
            let v = parseFloat(c.value.toString());
            if(c.value && !isNaN(v)) {
              if(this.total_columns[i]==undefined) this.total_columns[i]=0;
              this.total_columns[i]+=v;
            }
          };
        }
      }
    }

  }


  setFilters():void{

    this.filter_fieldvalue.mode=FilterMode.custom;
    this.filter_fieldvalue.fields=[];
    this.filter_fieldvalue.value="";
    this.filter.push(this.filter_fieldvalue);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("p.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.filter_id_address.mode=FilterMode.normal;
    this.filter_id_address.fields=[];
    this.filter_id_address.fields.push("p.id_address");
    this.filter_id_address.value="";
    this.filter.push(this.filter_id_address);

    this.filter_phase.mode=FilterMode.normal;
    this.filter_phase.fields=[];
    this.filter_phase.fields.push("p.phase");
    this.filter_phase.nullvalue=0;
    this.filter_phase.value=0;
    this.filter.push(this.filter_phase);

    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("addr.name");
     this.filter_search.fields.push("p.code");
    this.filter_search.fields.push("p.name");
    this.filter_search.fields.push("p.description");
    // this.filter_search.fields.push("p.note");
    this.filter_search.value="";
    this.filter.push(this.filter_search);

    if(this.mode!="modal" && this.mode!="embedded")
      Globals.navigation.getStateFilters(this.constructor.name+this.instance,this.filter);

    this.ordering.field="p.date";
    this.ordering.mode=OrderingMode.discendent;  
    this.isFilterSet=true;

  }


  ngOnChanges():void{
    if(this.id_address>0) //avvia la ricerca quando il filtro è attivo
      this.updateList(this.id_address);
  }


  updateList(id_address:number=0):void{
    if(!this.isFilterSet)
        this.setFilters();  
    
    if(id_address>0){
      this.filter_id_address.value=id_address.toString();
    }
    
    this.getItems();
  }


  duplicate(record:any) {  
    record.name = record.name+'_copia';
    const date_now: Date = new Date();  
    record.date = formatDate(date_now,'yyyy-MM-dd',"en-EN");
    super.duplicate.apply(this, arguments);  
  }


  calculateSelected(r:any, isChecked: boolean) {
    if (!r) {
      this.num_selected=0;
      this.total_amount_selected=0;
      this.total_paid_selected=0;
      this.total_cost_selected=0;
      return;
    }

    if (isChecked) {      
      this.num_selected+=1
      this.total_amount_selected+=parseFloat(r.amount);
      this.total_paid_selected+=parseFloat(r.paid);
      this.total_cost_selected+=parseFloat(r.cost);     
    } else {
      this.num_selected-=1
      this.total_amount_selected-=parseFloat(r.amount);
      this.total_paid_selected-=parseFloat(r.paid);
      this.total_cost_selected-=parseFloat(r.cost);
    }
  }

  setFilterFieldValue(field: any,value: any){

    //trova il filtro
    let found=false;
    for(let f of this.filterFieldValues){
      if(f.field==field){
        f.value=value;
        found=true;
      }
    }

    if(!found){
      let f:any={};
      f.field=field;
      f.value=value;
      this.filterFieldValues.push(f);
    }

    let sql=[];
    for(let f of this.filterFieldValues){
      if(f.value!="")
        sql.push("__dossierfields.`"+f.field.name+"`=\""+f.value+"\"");
        //sql.push("dfv.id_field="+f.field.id+" AND dfv.value=\""+f.value+"\"")
    }

    if(sql.length>0){
      this.filter_fieldvalue.value=sql.join(" AND ");
    }else{
      this.filter_fieldvalue.value="";
    }
    
    this.getItems();
   
  }


}